import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, Users, UserCheck, Layers, ArrowRight } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import { FeaturedLayout } from '../layouts';
import { Card, CardContent } from '../ui';

const StatCard = ({ icon: Icon, label, value, onClick }) => (
  <Card
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick?.(); } }}
    className="group cursor-pointer transition hover:border-primary/40 hover:shadow-md"
  >
    <CardContent className="p-4 flex items-center justify-between gap-2">
      <div className="min-w-0">
        <div className="flex items-center gap-2 text-muted-foreground text-sm mb-1">
          <Icon className="h-4 w-4 shrink-0" />
          <span className="truncate">{label}</span>
        </div>
        <div className="text-3xl font-bold tabular-nums">{value ?? '—'}</div>
      </div>
      <ArrowRight className="h-4 w-4 shrink-0 text-muted-foreground opacity-0 transition group-hover:opacity-100" />
    </CardContent>
  </Card>
);

const PlatformDashboard = () => {
  const navigate = useNavigate();
  const [stats, setStats] = useState({});

  useEffect(() => {
    const loadStats = async () => {
      const [orgs, staff, grupos, jugadores] = await Promise.all([
        supabase.from('organizations').select('id', { count: 'exact', head: true }),
        supabase.from('staff').select('id', { count: 'exact', head: true }).eq('activo', true),
        supabase.from('grupos').select('id', { count: 'exact', head: true }).eq('estatus', 'Activo'),
        supabase.from('jugadores').select('id', { count: 'exact', head: true }).eq('activo', true),
      ]);

      setStats({
        orgs: orgs.count,
        staff: staff.count,
        grupos: grupos.count,
        jugadores: jugadores.count,
      });
    };

    loadStats();
  }, []);

  return (
    <FeaturedLayout title="Platform Admin">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <StatCard
            icon={Building2}
            label="Organizaciones"
            value={stats.orgs}
            onClick={() => navigate('/platform/organizations')}
          />
          <StatCard
            icon={UserCheck}
            label="Staff activo"
            value={stats.staff}
            onClick={() => navigate('/platform/organizations')}
          />
          <StatCard
            icon={Layers}
            label="Grupos activos"
            value={stats.grupos}
            onClick={() => navigate('/platform/organizations')}
          />
          <StatCard
            icon={Users}
            label="Jugadores activos"
            value={stats.jugadores}
            onClick={() => navigate('/platform/organizations')}
          />
        </div>
      </div>
    </FeaturedLayout>
  );
};

export default PlatformDashboard;
